import { SECTION_TYPES } from "@/lib/constants/sections";
import { Video } from "lucide-react";

const embeddedVideoSection = {
  type: SECTION_TYPES.EMBEDDED_VIDEO,
  content: {
    header: "Watch a quick demo of our service!",
    subheader: "By watching this video, you'll get a better idea of what we have to offer.",
    videoUrl: "https://www.youtube.com/embed/1Bsgv6DnTiI",
  },
  meta: {
    displayName: "Video Embed",
    displayDescription: "Embed a video on this page.",
    displayIcon: Video,
  },
};

export default embeddedVideoSection;
